<template>
  <div class="flex-center">
        <p class="fincal-head" style="margin-left: -78%;margin-top: 7%">
        <a class="fincalrouter" id="top" href="">Home</a> » About us
      </p>
    <div class="about-box"  style="margin-top: 5%">
      <h2 class="h2title">Who We Are</h2>
      <p class="font">
        CSI is a data driven research and IT company founded by professionals
        who are experienced in credit and risk management, big data engineering,
        market research, and IT development. CSI is committed to providing
        digital research tools for professional investors and business managers
        around the globe. Employing a great data team, CSI has developed a new
        generation intuitive research platform. This platform is supported by
        algorithm and model building, along with in-depth analysis of a large
        amount of data. CSI’s products and services provide objective, reliable,
        systematic, instant and visual business information for investors,
        researchers and decision makers to manage opportunities and risks
        effectively and efficiently in the global markets.
      </p>
    </div>
    <div class="about-boxtwo">
      <div class="about-boxtwo-left">
        <img
          class="about-boxtwo-left-img"
          src="../assets/other/pauls-photo-1-350x350.jpg"
          alt=""
        />
      </div>
      <div class="about-boxtwo-right">
        <p class="fonttwo">
          <!-- <span class="fontmax">“</span> -->
          <span class="fontmaxtitel">
            We have an unwavering commitment to become the trusted
resources of business intelligence for our clients around the world.
Our team of talented people work hard to meet the new
challenges of the ever-growing markets, and invested our
resources to create a strong and sustainable company. </span
          >
             <!-- <span class="fontmax">”</span> -->

        </p>
        <p class="pfont">Paul Boynton</p>
        <p class="pfonttwo">Co-Founder and Chief Operating Officer (COO)</p>
        <p class="pfonttree"><a href="https://www.linkedin.com/in/paul-boynton-8baa9522">Linkedin </a></p>
        <p class="pfont"  id="Purpose"> <img src="../assets/2024/03/Image-3-11-24-at-11.31AM.jpeg" alt=""></p>
      </div>
    </div>
    <div class="bg-yiying">
      <div class="about-box">
        <h2 class="h2title" >Our Purpose</h2>
        <p class="font">
         The CSI platform continues the devotion, vision and mission we've had from the beginning: to deliver B2B intelligence at the
highest level of coverage and quality. Our goal is to provide the foremost B2B intelligence platform in the industry. With a
data base of over 400 million companies in over 200 countries and a myriad of data points, we provide our clients with finely-
tuned corporate evaluations on a macro level. We always strive to improve and expand the products we provide so our clients
obtain the best possible value.
        </p>
      </div>
    
      <div class="about-box">
        <h2 class="h2title">Our Corporate Strategy</h2>
        <div
          class="flex-center"
          style="justify-content: space-between; margin: 0px -5%"
        >
          <div class="iwithtext" style="margin-bottom: 60px;">
            <div class="iwt-icon">
              <img
                class="aboutimg"
                src="../assets/aboutimg/lead-and-deliver copy.png"
                alt=""
              />
            </div>
            <div class="iwt-text">
              <h3>Lead and deliver</h3>
              <ul class="iwt-textul">
                <li>
                  Meet growing demand through sustainable development
                </li>
                <li> Provide
                  high quality services and one stop value added solutions</li>
                <li>Accelerate our pace of innovation</li>
              </ul>
            </div>
          </div>
          <div class="iwithtext">
            <div class="iwt-icon">
              <img
                class="aboutimg"
                src="../assets/aboutimg/optimize-value.png"
                alt=""
              />
            </div>
            <div class="iwt-text">
              <h3 style="color: #62b746">Optimize Value</h3>
              <ul class="iwt-textul">
                <li>Maximize the value of 3ACredit’s resource</li>
                <li>
                  Create great long-term returns through managing financial
                  performance
                </li>
                <li>Develop and maintain strong strategic partnerships</li>
                <li>Consider interests of all shareholders</li>
              </ul>
            </div>
          </div>
          <div class="iwithtext">
            <div class="iwt-icon">
              <img
                class="aboutimg"
                src="../assets/aboutimg/build-our-brand.png"
                alt=""
              />
            </div>
            <div class="iwt-text">
              <h3 style="color: #fbbd18">Build your brand</h3>
              <ul class="iwt-textul">
                <li>Focus on greater customer satisfaction by adding values</li>
                <li>Increase the value of our network</li>
              </ul>
            </div>
          </div>
          <div class="iwithtext">
            <div class="iwt-icon">
              <img
                class="aboutimg"
                src="../assets/aboutimg/build-our-culture copy.png"
                alt=""
              />
            </div>
            <div class="iwt-text">
              <h3 style="color: #616362">Build our culture</h3>
              <ul class="iwt-textul">
                <li>Develop our people and capability</li>
                <li  id="Team">Share knowledge and collaborate across our organization</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="background-color: #fff">
    <div class="about-box" >
      <h2 class="h2title">Our Team</h2>
      <p class="font">
        CSI is guided by executives that have led organizations to the top
        echelons of industry, all of which have a passion for corporate
        analytics as the driver of empowerment and security for international
        trade. Our leadership crosses the spectrum of the B2B industry – experts
        in data collection, composition, verification, credit
        appraisal/analytics and marketing at the highest level of industry.
      </p>
    </div>
    <div class="about-box" style="margin-top: -2%; margin-bottom: 6%">
      <h2 class="h2title">Join Our Team</h2>
      <p class="font">
        We’re looking for talented people with skills, curiosity, drive and a
        collaborative attitude to enable digital transformation in locations
        worldwide. We value diversity, and we hire people from backgrounds as
        varied as the university, armed forces and industry.
      </p>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Products",
  data() {
    return {};
  },
  watch: {
    "$route.hash": function () {
      // 在这里可以处理hash变化后的逻辑
      this.scrollToAnchor();
    },
  },
  methods: {
    scrollToAnchor() {
      const el = document.querySelector(this.$route.hash);
        
      el.scrollIntoView({ behavior: "smooth" });
    },
  },
  mounted() {
      //  window.scrollTo(0, 0);
     this.scrollToAnchor();
   
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.img {
  height: 500px;
  width: 100%;
}
.fincalrouter {
  color: #1290c9;
  text-decoration: none;
}
.h2title {
  font-size: 46px;
font-family: "Alegreya Sans" !important;
  margin-bottom: 24px;
}
.flex-center {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.font {
    /* font-family: "Roboto" !important; */
    font-family: 'Alegreya Sans' !important;
  font-size: 18px;
  line-height: 32px;
  text-align: left;
}
.about-box {
  padding: 0 4%;
  text-align: center;
  margin: 5%;
  margin-bottom: 3%;
}
.about-boxtwo {
  display: flex;
  box-shadow: 0px 4px 11px 10px rgba(0, 0, 10, 0.1);
  padding: 40px 4%;

  margin: 6%;
  margin-bottom: 3%;
}
.fonttwo {
  font-size: 33px;
  color: #1290c9;
  line-height: 32px;
  position: relative;

  padding-top: 20px;
}
.about-boxtwo-right {
}
.fontmax {
  position: absolute;
  font-size: 110px;
  color: #1290c9;
  height: 30px;
  top: 40px;
}
.fontmaxtwo {
  position: absolute;
  font-size: 110px;
  color: #1290c9;
  bottom: -40px;
}
.fontmaxtitel {
  display: inline-block;
  margin-left: 70px;
  position: relative;
   font-family: 'Alegreya Sans' !important;
}
.about-boxtwo-left-img {
  height: 280px;
  width: 280px;
  border-radius: 50%;
}
.pfont {
  margin-left: 70px;
  font-size: 24px;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 5px;
}
.pfonttwo {
  margin-left: 70px;
  font-size: 24px;
  color: #333;
}
.pfonttree a{
    margin-left: 70px;
  font-size: 18px;
  color: #abb8c3;
      color: #1290c9;
}
.bg-yiying {
  width: 100%;
  background-color: #f0f2f6;
}
.iwithtext {
  width: 48%;
  display: flex;
}
.aboutimg {
  height: 80px;
  width: 80px;
}
.iwt-text {
  text-align: left;
  margin-left: 20px;
}
.iwt-textul {
  margin-left: 40px;
   /* font-family: "Roboto" !important; */
    font-family: "Alegreya Sans" !important;
  font-size: 18px;
  line-height: 32px;
  font-weight: 400;
}
h3 {
 font-family: "Alegreya Sans" !important;
  font-size: 28px;
  line-height: 38px;
  font-weight: 500;
  color: #3d7cbf;
  text-align: left;
  margin-bottom: 8px;
}
@media screen and (max-width: 1000px) {
.iwithtext {
  width: 98%;
  display: flex;
}
.fonttwo{
  font-size: 18px;
}
.fincal-head{
  margin-top: 20% !important;
  margin-left: -58% !important;
}
.about-boxtwo{
  flex-wrap: wrap;
  justify-content: center;
  background-color: #fff;

}
.fontmaxtitel{
  margin-left: 0px;
  margin-top: 30px;
}
}
</style>